const EventCopyHistoryDetails = require('./EventCopyHistoryDetails');
const EventCopyHistory = require('./EventCopyHistory');

module.exports = angular.module('backstage.controllers.events.copy', [])
    .controller('EventCopyHistoryDetails', EventCopyHistoryDetails)
    .controller('EventCopyHistory', EventCopyHistory)
    .name;
